import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const integrationJobsPage = {
    mobile: {
        headerContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            padding: "2vw 2.5vw",
            backgroundColor: Color.White,
            borderRadius: '2vw',
            boxShadow: '0 0.2vw 1vw' + Color.LightAsh
        },
        logoBox: {
            flexShrink: 0,
            width: "30vw",
            height: "25vw"
        },
        logoImage: {
            width: "100%",
            height: "100%",
            objectFit: 'contain'
        },
        descriptionText: {
            fontSize: '3.5vw',
            lineHeight: '1.4',
            textAlign: "justify",
            padding: "0vw 2vw"
        },
        baseWrapper: {
            width: "90%",
            overflow: "visible",
            margin: "4vw 4.83vw 0 4.83vw",
            touchAction: "pan-y",
            willChange: "height"
        },
        sectorTabsWrapper: {
            display: "flex",
            flexWrap: "nowrap",
            overflowX: "auto",
            gap: "2vw",
            marginBottom: "5vw",
            padding: "0 4.83vw 2vw 4.83vw"
        },
        sectorTab: {
            padding: "2vw 4vw",
            color: Color.Blue,
            backgroundColor: "unset",
            borderRadius: "1.5vw",
            fontSize: "3.5vw",
            fontFamily: Font.Poppins,
            border: "0.2vw solid " + Color.Blue,
            cursor: "pointer",
            whiteSpace: "nowrap",
            flexShrink: 0,
            selected: {
                backgroundColor: Color.LightBlue
            }
        },
        searchInputWrapper: {
            display: "flex",
            justifyContent: "end",
            margin: "4vw 0vw 3vw"
        },
        searchInput: {
            border: "0.7vw solid " + Color.Blue,
            width: "50%",
            height: "7vw",
            textAlign: "center"
        },
        jobsCount: {
            loaderWrapper: {                
                margin: "0 4.83vw 7.25vw",
                height: "12.56vw"
            },
            wrapper: {
                display: "flex",
                border: "1px solid " + Color.Blue,
                borderRadius: "2.41vw",
                backgroundColor: Color.LightBlue,
                alignItems: "center" as "center",
                justifyContent: "center" as "center",
                height: "auto",
                fontSize: "3vw",
                color: Color.Blue,
                marginBottom: "7.25vw",
                fontFamily: Font.Poppins,
                fontWeight: 500,
                textAlign: "center",
                minHeight: "12.07vw"
            },
            countText: {
                margin: "2.12vw",
                maxWidth: "85vw",
                wordWrap: "break-word",
                whiteSpace: "normal"
            },
            noResults: {
                textAlign: "center" as "center",
                color: Color.SharpAsh,
                fontSize: "4.34vw",
                marginTop: "5vh",
                zero: {
                    fontWeight: "bold",
                    color: Color.DeepBlack
                },
                wrapper: {
                    borderRadius: "2.41vw",
                    border: "1px solid " + Color.HarvestGold,
                    backgroundColor: Color.LightGold,
                    display: "flex",
                    alignItems: "center" as "center",
                    justifyContent: "center" as "center",
                    padding: "2.89vw 4.83vw",
                    color: Color.HarvestGold,
                    margin: "2.41vw 4.83vw 7.24vw 4.83vw",
                    fontFamily: Font.Poppins
                },
                icon: {
                    marginRight: "2.41vw",
                    width: "7.24vw",
                    height: "7.24vw"
                }
            },
            count: {
                fontWeight: "bold",
                marginRight: "0.70vw"
            }
        },
        card: {
            detailWrapper: {
                width: "100%"
            },
            appliedText: {
                width: "26.57vw",
                height: "5vw",
                color: Color.White,
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "2.40vw",
                backgroundColor: Color.Green,
                border: "none",
                borderRadius: "1.2vw",
                cursor: "pointer",
                position: "relative",
                top: "1.2vw",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textTransform: "uppercase"                
            },
            saveJobWrapper: {
                display: "none"
            }
        },
        pagination: {
            margin: "9.66vw auto 0 auto"
        },
        logoWrapper: {
            width: "30vw",
            height: "22vw",
            marginLeft: "59vw"
        },
        poweredByLogo: {
            width: "100%",
            height: "100%"
        }
    },
    desktop: {
        headerContainer: {           
            flexDirection: 'row',
            alignItems: 'center',
            padding: '2vw 7vw',
            gap: '2vw'
        },
        logoBox: {
            width: "9vw",
            height: "7vw"
        },
        descriptionBox: {
            flexGrow: 1,
        },
        descriptionText: {
            fontSize: '1.2vw',
            lineHeight: '1.5',
            margin: "unset"
        },
        baseWrapper: {
            width: "auto",
            margin: "2.86vw 11.29vw 0",
            overflow: "hidden"
        },
        sectorTabsWrapper: {
            display: "flex",
            flexWrap: "wrap",
            overflowY: "auto",
            maxHeight: "12vw",
            gap: "1.2vw",
            marginBottom: "2.5vw",
            padding: "0.5vw",
            justifyContent: "center",
            "&::-webkit-scrollbar": {
                width: "0.4vw",
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: Color.MiddleAsh,
                borderRadius: "1vw",
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: Color.LightAsh,
            }
        },
        sectorTab: {
            padding: "0.4vw 1vw",
            borderRadius: "0.5vw",
            fontSize: "1.34vw",
            fontFamily: Font.Poppins,
            color: Color.Blue,
            border: "0.2vw solid " + Color.Blue,
            cursor: "pointer",
            whiteSpace: "nowrap",
            flexShrink: 0,
            height: "fit-content",
            selected: {
                backgroundColor: Color.LightBlue
            }
        },
        searchInputWrapper: {
            margin: "4vw 0vw 2vw"
        },
        searchInput: {
            border: "0.2vw solid " + Color.Blue,
            width: "25%",
            height: "2vw"
        },
        jobsCount: {
            loaderWrapper: {
              margin: "0 0 1.56vw 0",
              height: "calc(2.6vw + 1px)"
            },
            wrapper: {
                margin: "0 0 1.56vw 0",
                fontSize: "0.937vw",
                borderRadius: "0.52vw",
                minHeight: "2.6vw"
            },
            countText: {
                margin: "0.67vw 0.62vw",
                maxWidth: "unset"
            },
            noResults: {                              
                marginTop: "3.38vw",
                fontSize: "0.937vw",
                wrapper: {
                    width: "49.47vw",
                    borderRadius: "0.52vw",
                    margin: "1.04vw auto auto auto",
                    padding: "1.56vw 0 1.56vw 0"
                },
                icon: {
                    marginRight: "1.02vw",
                    width: "1.58vw",
                    height: "1.58vw"
                }
            },
            count: {
                marginRight: "0.2vw"
            }
        },
        card: {
            detailWrapper: {
                width: "60vw"
            },
            appliedText: {
                width: "9.07vw",
                height: "1.2vw",
                fontSize: "0.78vw",
                borderRadius: "0.26vw",
                paddingTop: "0.3vw",
                position: "unset",
                display: "unset"
            }            
        },        
        pagination: {
            margin: "unset",
            width: "auto",
            justifyContent: "center"
        },
        logoWrapper: {
            width: "16vw",
            height: "9vw",
            marginLeft: "60vw"
        }
    } 
}